import { createSelector } from 'reselect';

import { selectDataSubjects } from '@main/privacy-center/src/containers/ActiveDataSubject/selectors';
import { selectIsLoggedIn } from '@main/privacy-center/src/containers/App/selectors';

import type { TakeControlState } from './slice';

/**
 * The selector for the `TakeControl` state store slice
 */
export const getTakeControlSlice = (state: any): TakeControlState =>
  state.TakeControl;

export const selectDisabledActions = createSelector(
  getTakeControlSlice,
  ({ disabledActions }) => disabledActions,
);

export const TAKE_CONTROL_MODAL_KEY = 'take-control' as const;
export const SELECT_SUBJECT_MODAL_KEY = 'select-subject' as const;
export const SELECT_REGIONS_MODAL_KEY = 'select-regions' as const;

/**
 * key type for these modals
 */
export type TakeControlModalKey =
  | typeof TAKE_CONTROL_MODAL_KEY
  | typeof SELECT_SUBJECT_MODAL_KEY
  | typeof SELECT_REGIONS_MODAL_KEY;

/**
 * The take control modal name when clicking the take control button
 */
export const selectTakeControlModalName = createSelector(
  selectIsLoggedIn,
  selectDataSubjects,
  (isLoggedIn, dataSubjects) =>
    isLoggedIn || dataSubjects.length === 1
      ? TAKE_CONTROL_MODAL_KEY
      : SELECT_SUBJECT_MODAL_KEY,
);
